import { createSlice } from "@reduxjs/toolkit";
import { getAllReport } from "@custom/rtk-apis/report/getAllReport";

export const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const getAllReportSlice = createSlice({
  name: "getAllReportsSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(getAllReport.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getAllReport.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getAllReport.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getAllReportSlice.reducer;
export const { revertStatus } = getAllReportSlice.actions;
